export enum LeadType {
    Corporate = 1,
    Affiliate = 2,
    Private = 3,
    Contact = 4,
    MarketsCorporate = 5,
    MarketsInstitution = 6,
    MarketsPartner = 7,
}

export enum LeadTypeString {
    Corporate = 'Corporate',
    Affiliate = 'Affiliate',
    Private = 'Private',
    Contact = 'Contact',
    MarketsCorporate = 'Markets - Corporate',
    MarketsInstitution = 'Markets - Institution',
    MarketsPartner = 'Markets - Partner',
}
